import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";

import config from "../config";
import { action, makeObservable, observable } from "mobx";

class FuelDetailsStore {
  fuelDetail = [];
  // users=[]
  // drivers=[]
  // staff=[]
  // passengers=[]
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      fuelDetail: observable,
      total: observable,
      loading: observable,
      loadData: action,
      addData: action,
      getFuelDetails: action,
      deleteRecord: action,
      exportExcel: action,
      checkCompany: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId }) {
    this.loading = true;
    const params = { companyId: companyId, offset: 0, limit: 15, page: 1 };
    const response = await postApi
      .getClient()
      .get(config.NodeUrl + "/FuelDetails/getFuelDetails", {
        params: params,
      });
    this.fuelDetail = response?.data?.data;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async addData(postData) {
    var fuelData = { postData };
    var response = await postApi
      .getClient()
      .post(config.NodeUrl + "/FuelDetails/saveFuelDetailsData", fuelData);
    return response.data;
  }

  async getFuelDetails({ fuelId, offset, limit }) {
    const params = { fuelId, limit: 1, offset: 0 };
    const response = await postApi
      .getClient()
      .get(config.NodeUrl + "/FuelDetails/getFuelDetails", {
        params: params,
      });
    return response.data.data[0];
  }

  async deleteRecord({ fuelId }) {
    var response = await postApi
      .getClient()
      .delete(config.NodeUrl + "/FuelDetails/deleteFuelDetails", {
        params: {
          fuelId: fuelId,
        },
      });
    return response;
  }

  async exportExcel(postData) {
    try {
      var response = await postApi
        .getClient()
        .post(
          config.NodeUrl + "/FuelDetails/exportFuelDetailsExcel",
          postData,
          {
            responseType: "blob",
          }
        );
      // console.log(response, "response");
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Fuel Details Report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async checkCompany(postData) {
    var fuelData = { postData };
    var response = await postApi
      .getClient()
      .post(config.NodeUrl + "/FuelDetails/checkCompany", fuelData);
    return response.data.data;
  }
}

export default FuelDetailsStore;
